module.exports = __webpack_public_path__ + "img/hero.75c44750.webp";